module.exports = __webpack_public_path__ + "img/read-img6.1fee3db1.png";